module.exports = __webpack_public_path__ + "static/media/banner3_2x.1feb20c4.jpg";